import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Alert, Dropdown, DropdownMenu, DropdownToggle, Form } from 'reactstrap';

//import images

//import Components
import FullScreenDropdown from '../Components/Common/FullScreenDropdown';
import LanguageDropdown from '../Components/Common/LanguageDropdown';
import LightDark from '../Components/Common/LightDark';
import NotificationDropdown from '../Components/Common/NotificationDropdown';
import ProfileDropdown from '../Components/Common/ProfileDropdown';

// import { useProfile } from 'Components/Hooks/UserHooks';
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from 'reselect';
import { getAuthMe } from '../live-slices/user/thunk';
import { changeSidebarVisibility } from 'live-slices/thunk';
import MyCartDropdown from 'Components/Common/MyCartDropdown';
// import SearchOption from 'Components/Common/SearchOption';
import logoDark from "../assets/images/BuyPass-logo.png";


const Header = ({ onChangeLayoutMode, layoutModeType, headerClass }: any) => {
    const dispatch: any = useDispatch();
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [alertMessage, setAlertMessage] = useState<string | null>(null);
    const [alertColor, setAlertColor] = useState("warning");


    const selectDashboardData = createSelector(
        (state: any) => state.Layout,
        (sidebarVisibilitytype) => sidebarVisibilitytype?.sidebarVisibilitytype
    );

    const selectuserProfile = createSelector(
        (state: any) => state.User,
        (user) => user?.user
    );
    const userProfile = useSelector(selectuserProfile);
    


    
    const location = useLocation();

    const isOnboarding = location.pathname === '/on-boarding';
    const isAnyStatusFalse =
        !userProfile?.storeStatus?.isStoreCreated ||
        !userProfile?.storeStatus?.isAddressAdded ||
        !userProfile?.storeStatus?.isIdBankDetails 
        // ||
        // !userProfile?.storeStatus?.isProductAdded;

        useEffect(() => {
    if (userProfile) {
        const { sellerStatus } = userProfile;
        if (isAnyStatusFalse) {
            setAlertMessage("Your profile is incomplete");
            setAlertColor("warning");
            setShowAlert(true);
        } else if (sellerStatus === "pending") {
            setAlertMessage("Your profile approval is pending from the admin");
            setAlertColor("warning");
            setShowAlert(true);
        } else if (sellerStatus === "inactive") {
            setAlertMessage("Your profile is currently inactive.");
            setAlertColor("danger");
            setShowAlert(true);
        } else {
            setAlertMessage(null);
            setShowAlert(false);
        }
    } else {
        setAlertMessage(null);
        setShowAlert(false);
    }
}, [userProfile, isAnyStatusFalse]);




    useEffect(() => {
    }, [userProfile])
    // Inside your component
    const sidebarVisibilitytype = useSelector(selectDashboardData);

    const [search, setSearch] = useState<boolean>(false);
    const toogleSearch = () => {
        setSearch(!search);
    };


    // const toogleMenuBtn = () => {
    //     var windowSize = document.documentElement.clientWidth;
    //     const humberIcon = document.querySelector(".hamburger-icon") as HTMLElement;
    //     dispatch(changeSidebarVisibility("show"));

    //     if (windowSize > 767)
    //         humberIcon.classList.toggle('open');

    //     //For collapse horizontal menu
    //     if (document.documentElement.getAttribute('data-layout') === "horizontal") {
    //         document.body.classList.contains("menu") ? document.body.classList.remove("menu") : document.body.classList.add("menu");
    //     }

    //     //For collapse vertical and semibox menu
    //     if (sidebarVisibilitytype === "show" && (document.documentElement.getAttribute('data-layout') === "vertical" || document.documentElement.getAttribute('data-layout') === "semibox")) {
    //         if (windowSize < 1025 && windowSize > 767) {
    //             document.body.classList.remove('vertical-sidebar-enable');
    //             (document.documentElement.getAttribute('data-sidebar-size') === 'sm') ? document.documentElement.setAttribute('data-sidebar-size', '') : document.documentElement.setAttribute('data-sidebar-size', 'sm');
    //         } else if (windowSize > 1025) {
    //             document.body.classList.remove('vertical-sidebar-enable');
    //             (document.documentElement.getAttribute('data-sidebar-size') === 'lg') ? document.documentElement.setAttribute('data-sidebar-size', 'sm') : document.documentElement.setAttribute('data-sidebar-size', 'lg');
    //         } else if (windowSize <= 767) {
    //             document.body.classList.add('vertical-sidebar-enable');
    //             document.documentElement.setAttribute('data-sidebar-size', 'lg');
    //         }
    //     }


    //     //Two column menu
    //     if (document.documentElement.getAttribute('data-layout') === "twocolumn") {
    //         document.body.classList.contains('twocolumn-panel') ? document.body.classList.remove('twocolumn-panel') : document.body.classList.add('twocolumn-panel');
    //     }
    // };


    const toogleMenuBtn = () => {
        const windowSize = document.documentElement.clientWidth;
        const humberIcon = document.querySelector(".hamburger-icon") as HTMLElement;

        // Toggle the hamburger icon state
        humberIcon.classList.toggle('open');

        // Check current sidebar size
        const currentSidebarSize = document.documentElement.getAttribute('data-sidebar-size');

        if (windowSize > 767) {
            // Toggle between full and collapsed sidebar
            if (currentSidebarSize === 'lg' || currentSidebarSize === '') {
                // Collapse sidebar (only show icons)
                document.documentElement.setAttribute('data-sidebar-size', 'sm');
            } else {
                // Expand sidebar
                document.documentElement.setAttribute('data-sidebar-size', 'lg');
            }
        } else {
            // For small screens, always enable the sidebar fully
            document.body.classList.add('vertical-sidebar-enable');
            document.documentElement.setAttribute('data-sidebar-size', 'lg');
        }

        // Handle horizontal layout menu toggle
        if (document.documentElement.getAttribute('data-layout') === "horizontal") {
            document.body.classList.toggle("menu");
        }

        // Handle two-column layout toggle
        if (document.documentElement.getAttribute('data-layout') === "twocolumn") {
            document.body.classList.toggle('twocolumn-panel');
        }
    };


    return (
        <React.Fragment>

            <header id="page-topbar" className={headerClass + " mobile-hide"}>
                <div className="layout-width">
                {showAlert && (
                        <Alert className="shadow dashboardAlert" color={alertColor}>
                            <strong>{alertMessage}</strong>
                        </Alert>
                    )}
                    <div className="navbar-header">
                        <div className="d-flex">
                  
                            {isOnboarding && isAnyStatusFalse ? (
                                <img src={logoDark} alt="BuyPass Logo" height="41" width="160" />
                            ) : (
                                <>
                                    <button
                                        onClick={toogleMenuBtn}
                                        type="button"
                                        className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger shadow-none"
                                        id="topnav-hamburger-icon"
                                        data-testing-id="hamBurgurButton_Header"
                                    >
                                        <span className="hamburger-icon">
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                        </span>
                                    </button>
                                    {/* <SearchOption /> */}
                                </>
                            )}
                        </div>
                     

                        <div className="d-flex align-items-center">

                            <Dropdown isOpen={search} toggle={toogleSearch} className="d-md-none topbar-head-dropdown header-item">
                                <DropdownToggle type="button" tag="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle">
                                    <i className="bx bx-search fs-22"></i>
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
                                    <Form className="p-3">
                                        <div className="form-group m-0">
                                            <div className="input-group">
                                                <input type="text" className="form-control" placeholder="Search ..."
                                                    aria-label="Recipient's username" />
                                                <button className="btn btn-primary" type="submit"><i
                                                    className="mdi mdi-magnify"></i></button>
                                            </div>
                                        </div>
                                    </Form>
                                </DropdownMenu>
                            </Dropdown>

                            {/* LanguageDropdown */}
                            {/* <LanguageDropdown /> */}

                            {/* WebAppsDropdown */}
                            {/* <WebAppsDropdown /> */}

                            {/* MyCartDropdwon */}
                            {/* <MyCartDropdown /> */}

                            {/* FullScreenDropdown */}
                            <FullScreenDropdown />

                            {/* Dark/Light Mode set */}
                            {/* <LightDark
                                layoutMode={layoutModeType}
                                onChangeLayoutMode={onChangeLayoutMode}
                            /> */}

                            {/* NotificationDropdown */}
                            {/* <NotificationDropdown /> */}

                            {/* ProfileDropdown */}
                            <ProfileDropdown />
                        </div>
                    </div>
                </div>
            </header>

               {showAlert && (
                        <Alert className="shadow dashboardAlert mobile-show" color={alertColor} style={{ position: 'fixed', top: '0px', right: '0px', zIndex: "1000" , width :"100%" ,}}>
                            <strong>{alertMessage}</strong>
                        </Alert>
                    )}
            {/* <header id="page-topbar-mobile" className={headerClass + " mobile-show"}>
                <div className='d-flex align-items-center justify-content-between'>
                   <h3>Page Title</h3>
                   <div className='actionSide'>
                        <button><i className="ri-qr-scan-2-line"></i></button>
                        <button><i className="ri-notification-fill"></i></button>
                   </div>
                </div>
            </header> */}
        </React.Fragment>
    );
};

export default Header;